import type { HTMLAttributes, ReactNode } from 'react';
import { PanelsTopLeft } from 'lucide-react';
import { cn } from './cn.js';

export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'hue-card rounded-2xl border border-surface-border bg-surface-card p-6 shadow-card',
        className,
      )}
      {...props}
    />
  );
}

export function CardHeader({
  title,
  icon,
  action,
  id,
  level = 2,
}: {
  title: ReactNode;
  id?: string;
  level?: 2 | 3;
  icon?: ReactNode;
  action?: ReactNode;
}) {
  const Heading: 'h2' | 'h3' = `h${level}`;
  return (
    <header className="mb-4 flex flex-wrap items-center justify-between gap-x-4 gap-y-2 border-b border-surface-border pb-3">
      <Heading
        id={id}
        className="flex min-w-0 items-center gap-2 text-sm font-semibold text-content"
      >
        <span className="inline-flex shrink-0 text-brand-500" aria-hidden="true">
          {icon ?? <PanelsTopLeft className="size-4" />}
        </span>
        <span className="min-w-0 break-words">{title}</span>
      </Heading>
      {action}
    </header>
  );
}
